import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import {
  Paper,
  TextField,
  withStyles,
} from '@material-ui/core'
import {
  CloudDownload as CloudDownloadIcon,
} from '@material-ui/icons'

import { createCSV } from '../helpers'
import Button from './Button'
import Pagination from './Pagination'


const styles = theme => ({
  root: {
    background: 'white',
    marginTop: theme.spacing(2),
  },
  input: {
    marginTop: 0,
    marginBottom: theme.spacing(1),
  },
  disableMargin: {
    marginTop: 0,
  },
})


class Automation extends PureComponent {
  /* LIFECYCLE */

  state = {
    query: '',
    pendingCSV: false,
  }


  /**
   * @componentWillMount
   */
  componentDidMount() {
    if (this.props.request) {
      this.handlePageChange()
    }
  }

  componentDidUpdate(prevProps) {
    const { items, isLoading } = this.props

    if (items !== prevProps.items && items.length > 0 && !isLoading && this.state.pendingCSV) {
      this.handleCreateCSV(items)
    }
  }


  /* METHODS */

  /**
   * Handle export data to CSV
   */
  handleExport = async () => {
    this.setState({ pendingCSV: true })

    this.props.request({
      limit: 1000,
    })
  }

  handleCreateCSV = (items) => {
    const { row, head, csvTitle } = this.props

    createCSV(head, items.map((item) => {
      const values = row(item)

      if (Array.isArray(values)) {
        return values.map(v => typeof v === 'object' ? v.data : v)
      }

      return typeof values === 'object' ? values.data : values
    }), csvTitle)

    this.setState({
      pendingCSV: false,
    }, this.handleFirst)
  }

  handlePageChange = (page = 0) => {
    const { query } = this.state

    this.props.request(query.length > 2 ? query : '', { page })
  }

  handleInputChange = (e) => {
    const { page } = this.props
    const { value } = e.target
    const lastQueryLength = this.state.query.length

    this.setState({
      [e.target.name]: value,
    }, () => {
      if (value.length > 2) {
        this.handlePageChange(0)
      } else if (value.length < 3 && lastQueryLength > 2) {
        this.handlePageChange(0)
      }
    })
  }


  /* RENDER */

  /**
   * @render
   * @returns {JSX}
   */
  render() {
    const {
      page,
      count,
      classes,
      onExport,
      children,
      isLoading,
      className,
      totalPages,
      disableMargin,
      disableSearch,
      disablePagination,
    } = this.props
    const {
      query,
    } = this.state

    return (
      <>
        <Paper
          className={classNames(classes.root, {
            [classes.disableMargin]: disableMargin,
          }, className)}
        >
          {!disableSearch && (
            <TextField
              fullWidth
              name="query"
              value={query}
              label="Finder"
              margin="normal"
              variant="filled"
              className={classes.input}
              onChange={this.handleInputChange}
              placeholder="Enter email, name or tag"
              InputLabelProps={{
                shrink: true,
              }}
            />
          )}

          {children}

          {!disablePagination && (
            <Pagination
              page={page}
              count={count}
              isLoading={isLoading}
              totalPages={totalPages}
              onPageChange={this.handlePageChange}
            />
          )}
        </Paper>

        {onExport && (
          <Button
            fullWidth
            color="primary"
            className="mt3"
            variant="contained"
            onClick={onExport}
          >
            <CloudDownloadIcon className="mr3" /> Export CSV
          </Button>
        )}
      </>
    )
  }
}


Automation.defaultProps = {
  row: [],
  head: [],
  items: [],
}


Automation.propTypes = {
  row: PropTypes.func,
  page: PropTypes.number,
  hasMore: PropTypes.bool,
  onClick: PropTypes.func,
  count: PropTypes.number,
  children: PropTypes.node,
  endBefore: PropTypes.any,
  onExport: PropTypes.func,
  isLoading: PropTypes.bool,
  startAfter: PropTypes.any,
  csvTitle: PropTypes.string,
  hasPrevious: PropTypes.bool,
  className: PropTypes.string,
  totalPages: PropTypes.number,
  disableMargin: PropTypes.bool,
  request: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  head: PropTypes.arrayOf(PropTypes.any),
  items: PropTypes.arrayOf(PropTypes.object),
}


export default withStyles(styles)(Automation)
